import { User } from "@/graphql/types";
import { InjectionKey } from "@vue/composition-api";

export const TestUserKey: InjectionKey<User> = Symbol();
